import React from 'react';
import { DashBoardCommonGrid } from '../../DashBoardNew/dashBoardNewStyles';
import { CommonGrid } from 'styledComponents/common';
import HourlyEstimatedVsCompletedChart from './HourlyEstimatedVsCompletedChart';
import TopCustomers from './TopCustomers';

const DashBoardFourthSection = ({
  getDashboardEstimation,
  estimationIsLoading,
  estimationData,
  getDashboardTopCustomers,
  topCustomersIsLoading,
  topCustomers,
  selectedOrganization,
}) => {
    const orgType = selectedOrganization?.type || 'operation';
    const isOperationType = orgType === 'operation';
    return (
       <DashBoardCommonGrid responsiveBreakpoint="768px" responsiveColumns="1fr" columns="1fr 1fr" gap="20px">
        <CommonGrid  columns="1fr" gap="20px">
            <HourlyEstimatedVsCompletedChart 
              getDashboardEstimation={getDashboardEstimation} 
              estimationIsLoading={estimationIsLoading} 
              estimationData={estimationData}
              selectedOrganization={selectedOrganization}
            />
        </CommonGrid>
        <CommonGrid columns="1fr" gap="20px">
            {!isOperationType && <TopCustomers getDashboardTopCustomers={getDashboardTopCustomers} topCustomersIsLoading={topCustomersIsLoading} topCustomers={topCustomers} selectedOrganization={selectedOrganization} />}
        </CommonGrid>
       </DashBoardCommonGrid>
    );
};

export default DashBoardFourthSection;